module.exports = __webpack_public_path__ + "img/shopping-cart-solid2.8bf1af37.svg";